
export class SetPlateGateDto {

	public accessControlId: number | null = 0;
	public plate: string | null = "";
	public routeId: number | null = 0;
	public phaseId: number | null = 0;
	public entryGateId: number | null = 0;
	public exitGateId: number | null = 0;

	public static build(accessControlId: number | undefined, plate: string, routeId: number | undefined, phaseId: number | undefined, entryGateId: number, exitGateId: number): SetPlateGateDto {
		let result: SetPlateGateDto = new SetPlateGateDto();
		result.accessControlId = accessControlId == undefined ? 0 : accessControlId;
		result.plate = plate;
		result.routeId = routeId == undefined ? 0 : routeId;
		result.phaseId = phaseId == undefined ? 0 : phaseId;
		result.entryGateId = entryGateId;
		result.exitGateId = exitGateId;
		return result;
	}
}
